import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, inject } from 'vue';
import { ClickoutUrl } from '@/helpers/clickout-helper';

import { SnowplowContext, SnowplowPackageContext, SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { PresentationType } from '@/@types/graphql-types';
import { OFFER_ENTITYID_KEY } from '@/helpers/composables/useProvideClickoutPlacement';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { OfferLocation } from '@/helpers/offer-helper';
import { storeToRefs } from 'pinia';
import { useAppStore } from '@/stores/pinia/useAppStore';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

type BuyboxRowOffer = TitleOfferFragment & {
	iconUrl?: string;
	icons?: string[];
	bundleId?: number;
	bundleTechnicalName?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'BundleOffer',
  props: {
    title: null,
    offer: null,
    isBannerBuyBox: { type: Boolean, default: false },
    additionalContexts: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail, offer: BuyboxRowOffer, isBannerBuyBox: boolean, additionalContexts: SnowplowContext[] };



const { country } = storeToRefs(useLanguageStore());
const { xServeTrack } = storeToRefs(useAppStore());

const titleContext = inject('titleContext', ref<SnowplowTitleContextGraphql | null>(null));
const titleSourceId = inject<string | null>('titleSourceId', null);
const episodeEntityId = inject<string | undefined>(OFFER_ENTITYID_KEY, undefined);

const jwRawEntityId = computed(() => episodeEntityId ?? props.title.id);

const bundleLabelSuffix = computed(() => {
	switch (props.offer.presentationType) {
		case PresentationType['4K']:
			return '4k';
		case PresentationType.Hd:
			return 'HD';
		case null:
		default:
			return '';
	}
});

const packageContext = computed(
	() =>
		new SnowplowPackageContext(
			props.offer.package.packageId,
			props.offer.package.technicalName,
			'bundle',
			props.offer.bundleId,
			props.offer.bundleTechnicalName
		)
);

const bundleOfferUrl = computed(() => {
	const url = new ClickoutUrl(() => ({ ...props.offer, presentationType: props.offer.presentationType }))
		.setTitleSourceId(titleSourceId)
		.set('uct_country', country.value)
		.addContexts(packageContext)
		.addContexts(titleContext)
		.setForTracking(
			'offerLocation',
			props.isBannerBuyBox ? OfferLocation.BANNER_BUYBOX : OfferLocation.REGULAR_BUYBOX
		)
		.updateContext('TitleContextGraphql', 'jwRawEntityId', jwRawEntityId.value)
		.setCanary(xServeTrack.value);

	// Bypass UCT for US users on bundle amazonstarzamazonhbomax
	if (props.offer.bundleTechnicalName === 'amazonstarzamazonhbomax') {
		url.set('uct_ct', 'bypass');
	}

	return url;
});

return { __sfc: true,props, country, xServeTrack, titleContext, titleSourceId, episodeEntityId, jwRawEntityId, bundleLabelSuffix, packageContext, bundleOfferUrl, ProviderIcon }
}

})